<template>
	<v-container grid-list-md>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-title primary-title>
						<v-btn
							icon
							@click="
								$inertia.visit(
									$route(
										'tenant.tables.index',
										$page.props.tenant.id
									)
								)
							"
							><v-icon>mdi-arrow-left</v-icon></v-btn
						>
						{{ $t("title.create_table") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<form-table
							v-model="item"
							:outlets="outlets"
						></form-table>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							@click.native="submit()"
							:loading="item.processing"
							:disabled="invalid"
						>
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Save") }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-container>
</template>
<script>
import FormTable from "../../../forms/FormTable.vue";
export default {
	props: ["data", "outlets"],
	components: { FormTable },
	data() {
		return {
			item: this.$inertia.form({
				name: null,
				description: null,
				outlet_id: null,
				image: {},
			}),
		};
	},
	methods: {
		submit() {
			this.item.post(
				this.$route("tenant.tables.store", this.$page.props.tenant.id)
			);
		},
	},
};
</script>
